import { Component, OnInit, ViewChildren, QueryList, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { APIConsentService } from '../../_services/consent/API-consent';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { DataSource } from '@angular/cdk/table';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { formatDate } from '@angular/common';
import { saveAs as importedSaveAs } from "file-saver";
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { Router, ActivatedRoute } from '@angular/router';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


const now = new Date();
const time_today = now.getTime();
const formatTime = formatDate(time_today, 'HH:mm', 'en-US', '+0530');
const currentdat = formatDate(now, 'dd-MM-yyyy', 'en-US', '+0530');
console.log("formatTime -- : ", formatTime);

export interface DialogData {
  setValue: string,
  setRole: string
}
@Component({
  changeDetection:ChangeDetectionStrategy.OnPush,
  selector: 'app-digital-consentsummary',
  templateUrl: './digital-consentsummary.component.html',
  styleUrls: ['./digital-consentsummary.component.css']
})
export class DigitalConsentsummaryComponent implements OnInit {

  maxDate: Date = new Date();
   mindate = new Date(now.getFullYear(), 0, 1);
   maxdate = new Date(now.getFullYear(), now.getMonth(), now.getDate())

  dataSource: MatTableDataSource<any>;
  
 
  fetchedData: any;
  noRecord: any;
  afterApply: boolean = false;
  creditBalance:any;
  //digitalconsentsummaryForm:any;
  //filterForm: any;
  //filterForm: FormGroup;
  //ngForm:FormGroup;
  digitalconsentsummaryForm: FormGroup;
  expirydate:any;
  PEName: any;
  pageNo: number = 1;
  pageSize: number = 5;
  length: number = 5;
  Param: any;
  CreditBalance:any;
  ExpiryDate:any;
  filterData: any;
  entityId: any;
  ActionSource: any;
  download: boolean = false;
  form1: any = {};
  data: any = {};
  

//  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
//  //@ViewChild(MatPaginator) paginator: MatPaginator;
//   @ViewChild(MatSort) t1sort: MatSort;

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChild('t1Sort') t1Sort: MatSort;

  dataSubject = new BehaviorSubject<any[]>([]);

  displayedColumns: string[] =['URN','RCID','Pack_Name', 'Requests_Allowed','Purchase_Dt','Purchase_Status'];

  constructor(
    private fb: FormBuilder,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
		private _route: ActivatedRoute,
    public dialog: MatDialog,
    private $: $BroadcastManagerService,
    private cst: APIConsentService,
    private router: Router) {
      this._route.params.subscribe((params) => {
        this.PEName = this.db.get(Constants.SESSSION_STORAGE, Constants.ORG_NAME);
        this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
      });
    }
   

  ngOnInit() {
 
    this.digitalconsentsummaryForm = this.fb.group({
			pe_name: ['',],
      creditBalance: ['',],
      expirydate: ['',],
		
		});
    this.maxDate.setDate(new Date().getDate());

		this.digitalconsentsummaryForm.controls['pe_name'].setValue(this.PEName);
    this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, this.entityId);
    this.fetchcreditbalance();   
    let data = {
   
        "Start_Date": "",
        "End_Date": "",
        "Entity_ID" :this.entityId 
      }
    this.digitalConsentFilter(data)
  }
  get f() { return this.digitalconsentsummaryForm.controls; }

  fetchcreditbalance() {
    var data = {
      EntityID: this.entityId
    }

    this.cst.fetchcreditbalance(data)
      .subscribe(r => {
        if (r.Status == "Success") {
          this.digitalconsentsummaryForm.controls['creditBalance'].setValue(r.CreditBal);
          this.digitalconsentsummaryForm.controls['expirydate'].setValue(r.Expiry_Dt);
        }
        else {
          this.$modal.errorModal({
            title: 'Digital Consent Recharge Summary Credit Pack',
            msg: r.message
          });

        }
      })

  }
  
  onChangeDataSource(value) {
   
    
    this.dataSource = new MatTableDataSource(value.Data);
   console.log("------------------values" + this.dataSource);
    this.dataSource.paginator = this.paginator.toArray()[0];
    console.log("values" + value);
    //this.dataSource.sort = this.t1Sort;
    this.noRecord = this.dataSource.connect().pipe(map(data => data.length === 0));
  }


  

  searchRequired: boolean = false;
  errorSerch() {
    if (this.form1.searchBy && !this.form1.search) {
      this.searchRequired = true;
    } else {
      this.searchRequired = false;

    }
  }
  onSubmitFilter(filterForm, form) {

    console.log(filterForm.value);
    console.log("hi !!!");
    var fdate = filterForm.startDate;
    var ldate = filterForm.endDate;
    var cdate = filterForm.currentDate;
    cdate = formatDate(Date.now(), 'yyyy-MM-dd', 'en-US', '+0530');

    if (typeof fdate === 'undefined' || fdate == null)
      fdate = "";
    else
      fdate = formatDate(filterForm.startDate, 'yyyy-MM-dd', 'en-US', '+0530');
    if (typeof ldate === 'undefined' || ldate == null)
      ldate = "";
    else
      ldate = formatDate(filterForm.endDate, 'yyyy-MM-dd', 'en-US', '+0530');
    var param = filterForm.search
    console.log("fdate", fdate);
    console.log("ldate", ldate);
     //var filterType
    // if (filterForm.searchBy)
    //   filterType = filterForm.searchBy;
    // if (filterForm.searchBy1)
    //   param = filterForm.searchBy1;

    var difference_in_Time = new Date(ldate).getTime() - new Date(fdate).getTime()
    var difference_in_Days = difference_in_Time / (1000 * 3600 * 24)
    console.log("difference_in_Timedifference_in_Time in days", difference_in_Time)



    if (fdate != "" && ldate == "") {
      ldate = cdate
    }

    this.data = {
    
      "Start_Date": fdate,
      "End_Date": ldate,
      "Entity_ID" :this.entityId 
    }
  
    if (fdate == "" && ldate == "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select any option'
      });
    }
    else if (fdate == "" && ldate != "") {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Please select Start date'
      });
    }
    else if (fdate > ldate) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'From Date cannot be after To Date'
      });
    }

    else if (fdate != "" && ldate != "" && difference_in_Days > 30) {
      this.$modal.errorModal({
        title: 'Error',
        msg: 'Date Difference should not be more than 30 days'
      });
    }
  
    else {
      this.data['Entity_ID'] = this.entityId
      this.digitalConsentFilter(this.data)
    }
  }   

  digitalConsentFilter(data) {

    this.cst.digitalConsentFilter(data)
      .subscribe(r => {
        console.log(r)
        this.fetchedData = JSON.stringify(r);
        console.log("----------fetcch---------------------",this.fetchedData)
        this.dataSource = r;
        console.log("---------datasource----------------",this.dataSource)
        this.onChangeDataSource(r);
       
      })
  }

  reset() {
    console.log("first reset function");
    this.afterApply = false;
  }

}




